import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyDeliveryNoteStatusBar, { BuyDeliveryNoteStatusBarNew, DeliveryNoteCreateStatusBarProps } from '../../../BuyDeliveryNoteStatusBar'
import BuyDeliveryNoteFinishedStepButtons, { BuyDeliveryNoteFinishedStepButtonsNew } from '../BuyDeliveryNoteFinishedStepButtons'

type BuyDeliveryNoteFinishedStepHeaderProps = & DeliveryNoteCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyDeliveryNoteFinishedStepHeaderDecider: React.FC<BuyDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyDeliveryNoteFinishedStepHeaderDefault} NewComponent={BuyDeliveryNoteFinishedStepHeaderNew} {...rest} />
    )
}

const BuyDeliveryNoteFinishedStepHeaderDefault: React.FC<BuyDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyDeliveryNoteStatusBar {...rest} />
            <BuyDeliveryNoteFinishedStepButtons {...rest} />
        </div>
    )
}

const BuyDeliveryNoteFinishedStepHeaderNew: React.FC<BuyDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyDeliveryNoteStatusBarNew {...rest} />
            <BuyDeliveryNoteFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyDeliveryNoteFinishedStepHeaderDecider